import React from "react";
import styled from 'styled-components';
import I10n from '../features/i10n';
import MsxIcons from '../features/msx-icons';
import PropTypes from 'prop-types';
import { possibleLengthUnitFormat } from '../constants';
import DropdownMenu from './dropdown_menu';

const DefaultIcon = styled.div`
  display: block;
`;

const HoverIcon = styled.div`
  display: none;
  width: 18px;
  color: rgb(98,100,105);
`;

const IconWrapper = styled.div`
  display: flex;
  min-width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 5px;
  text-decoration: none !important;

  :hover {
    ${DefaultIcon} {
      display: none;
    }

    ${HoverIcon} {
      display: flex;
      align-items: center;
    }
  }
`;

const MenuContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`;

const SectionTitle = styled.span`
  font-size: 14px;
  font-weight: bold;
  margin: 10px 0;
`;

const ParameterTitle = styled.span`
  white-space: nowrap;
`;

const ParameterLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const OptionWrapper = styled.div`
  display: flex;
  margin-left: 20px;
`;

const Button = styled.div`
  padding: 5px 20px;
  border: 1px solid #626469;
  ${props => props.selected ? 'background-color: #626469; color: white;' : ''}
  cursor: pointer;
`;


class ApplicationParameterMenu extends React.Component {

  static propTypes = {
    selectedLengthUnit: PropTypes.string,
    setParameters: PropTypes.func
  }

  renderToggle = () => {
    return (
      <IconWrapper>
        <DefaultIcon><MsxIcons name="settings" size="small"></MsxIcons></DefaultIcon>
        <HoverIcon><MsxIcons name="settings_hover" size="small"></MsxIcons></HoverIcon>
      </IconWrapper>
    );
  }

  renderContent = () => {
    return (
      <MenuContentWrapper>
        <SectionTitle>{I10n.get('app.parameters.unit_preferences.title')}</SectionTitle>
        <ParameterLine>
          <ParameterTitle>{I10n.get('app.parameters.unit_preferences.length.label')}</ParameterTitle>
          <OptionWrapper>
            <Button onClick={(e) => { this.props.setParameters({ lengthUnit: possibleLengthUnitFormat.mm }) }} selected={this.props.selectedLengthUnit === possibleLengthUnitFormat.mm}>{I10n.get('unit.mm', 'data')}</Button>
            <Button onClick={(e) => { this.props.setParameters({ lengthUnit: possibleLengthUnitFormat.inch }) }} selected={this.props.selectedLengthUnit === possibleLengthUnitFormat.inch}>{I10n.get('unit.inch', 'data')}</Button>
          </OptionWrapper>
        </ParameterLine>
      </MenuContentWrapper>

    );
  }

  render = () => {
    return (
      <DropdownMenu
        data-clickable
        toggleElement={this.renderToggle()}
        containerElement={this.renderContent()}
      >
      </DropdownMenu>
    );
  }
}

export default ApplicationParameterMenu;
